module.exports = __webpack_public_path__ + "img/chadle3_1.d86a51f8.png";